const v6ContextRoot = (widgetInstance) => widgetInstance.features &&
      widgetInstance.features.cxp &&
      widgetInstance.features.cxp.config.get &&
      widgetInstance.features.cxp.config.get('contextRoot');

/* global window */
const v5ContextRoot = () => window.b$ &&
      window.b$.portal &&
      window.b$.portal.config &&
      window.b$.portal.config.resourceRoot;

export default (widgetInstance) => v6ContextRoot(widgetInstance) || v5ContextRoot();



// WEBPACK FOOTER //
// ./lib-bb-widget/scripts/context-root.js